import type { Mixpanel } from 'mixpanel-browser';
import { inject } from 'vue';

export function useMixpanel() {
    const mixpanel = inject<Mixpanel>('mixpanel');
    return mixpanel;
}
